import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { hot } from 'react-hot-loader';
import ErrorBoundary from '@surfline/quiver-react/dist/ErrorBoundary';

import initializeAnonymousId from '../../utils/initializeAnonymousId';
import { GiftPurchase, NotFound, Redeem } from '../../containers';

const path = wt.funnel_config.funnelConfig && wt.funnel_config.funnelConfig.urlKey;
class App extends Component {
  constructor(props) {
    super(props);
    const {
      identity
    } = props;
    initializeAnonymousId(identity, 'gifts');
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="gift-container">
          <Switch>
            <Route path="/gift-cards" component={GiftPurchase} />
            <Route path="/redeem" component={Redeem} />
            <Route exact path={`/${path}`} component={Redeem} />
            <Route path="*" component={NotFound} status={404} />
          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}

export default hot(module)(App);
